import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-card-footer',
  templateUrl: 'card-footer.component.html',
  styleUrl: './card-footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class CardFooterComponent {}
